import React, {useState, useContext} from 'react'
import EditContent from './EditContent'
import EditMenu from './EditMenu'
import {EditedContext} from '../../../partials/Context'
import ChangeBtn from './partials/ChangeBtn';
import getCookie from '../../../partials/cookie';

import {LoadingContext} from '../../../partials/Context';

function DataEdit() {
  const [edited_item, setEditedItem] = useState(false);
  const [input_value, setInputValue] = useState('');
  const [lawyer_data, setLawyerData] = useState({});
  const [errors, setErrors] = useState([]);
  const [recommendation_sent, setRecommendationSent] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const csrftoken = getCookie('csrftoken')

  const changeBtn = (name) => {
    return (
      <ChangeBtn setEditedItem={setEditedItem} to_be_edited={name} edited_item={edited_item} updateProfile={updateProfile} setInputValue={setInputValue} lawyer_data={lawyer_data}/>
    )
  }

  const getCurrentLawyer = async (method, handleErrors) => {
    setLoading(true)
    let errors = [];
    const response = await fetch('/api/lawyer_profiles_extended/current/');
    const data = await response.json();

    if(!response.ok) {
      response.json().then(data => {
        errors = Object.values(data)
          handleErrors(errors)
          setLoading(false)
      })
    } else {
      setEditedItem(false);
      setLoading(false)
    }

    method(data);
  }

  const updateProfile = () => {
    setLoading(true)
    if (edited_item) {
      fetch(`/api/lawyer_profiles_extended/current/`, {
          method:'PATCH',
          headers: {
              'Content-Type': 'application/json',
              "X-CSRFToken": csrftoken
          },
          body: JSON.stringify (
                  {...input_value}
              )
      }).then( res => {
          if (res.ok) {
              getCurrentLawyer(setLawyerData, setErrors)
              setInputValue('')
              setLoading(false)
              setErrors([])
          } else {
              res.json().then(
                data => {
                  let tempErr = []
                  Object.keys(data).forEach(error => {
                    if (Array.isArray(data[error])) {
                      tempErr = [...tempErr, ...data[error]]
                    } else {
                      Object.keys(data[error]).forEach(key => {
                          tempErr = [...tempErr, ...data[error][key]]
                      })
                    }
                  })
                  setErrors(tempErr)
                  setLoading(false)
                }
              )
          }
      })
    }
  }
  return (
    <>
        <div className="background"></div>
        {recommendation_sent ? 
            <div className="alert alert-success">Prośba o rekomendację została wysłana</div>
          : null
          }
        <div id="data-edit" >
          <EditedContext.Provider value={{edited_item, setEditedItem, lawyer_data, setLawyerData, updateProfile, changeBtn, input_value, setInputValue, getCurrentLawyer, setErrors, errors}}>
            <EditContent recommendation_sent={recommendation_sent}/>
            <EditMenu setRecommendationSent={setRecommendationSent}/>
          </EditedContext.Provider>
        </div>
    </>
  )
}

export default DataEdit